import { render, staticRenderFns } from "./borderHorizontal.vue?vue&type=template&id=4abcad38&scoped=true"
import script from "./borderHorizontal.vue?vue&type=script&lang=ts&setup=true"
export * from "./borderHorizontal.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abcad38",
  null
  
)

export default component.exports